<!-- BEGIN CHANGE: Bulk Upload Dialog Template -->
<h2 mat-dialog-title class="dialog-title"><mat-icon>cloud_upload</mat-icon> Bulk Uploads</h2>
<mat-dialog-content class="content">
  <div class="sections">
    <section class="panel">
      <h3>PDF Files</h3>
      <button mat-stroked-button color="primary" (click)="pdfInput.click()" [disabled]="uploading || completed">
        <mat-icon>picture_as_pdf</mat-icon> Select PDFs
      </button>
      <input #pdfInput type="file" multiple accept="application/pdf" (change)="onSelectPdfs($event)" hidden>
      <div class="list" *ngIf="pdfItems.length">
        <div class="row" *ngFor="let p of pdfItems; let i = index">
          <mat-icon class="pdf">picture_as_pdf</mat-icon>
          <span class="name" [title]="p.file.name">{{p.file.name}}</span>
          <span class="size">{{p.file.size | number}} bytes</span>

          <div class="status-box" *ngIf="p.status==='validating'" style="display: flex; align-items: center; gap: 8px; color: #666;">
            <mat-spinner diameter="18"></mat-spinner>
            <span style="font-size: 13px;">Validating PDF...</span>
          </div>
          
          <div class="progress" *ngIf="p.status==='uploading'">
            <div class="bar" [style.width.%]="p.progress"></div>
          </div>
          <mat-icon *ngIf="p.status==='pending'">schedule</mat-icon>
          <mat-icon class="ok" *ngIf="p.status==='success'">check_circle</mat-icon>
          <mat-icon class="err" *ngIf="p.status==='error'" matTooltip="{{p.error}}">error</mat-icon>
          <mat-icon class="err" *ngIf="p.status==='invalid'" matTooltip="{{p.error || 'Invalid PDF'}}" style="color: darkorange;">warning</mat-icon>

          <button mat-icon-button color="warn" (click)="removePdf(i)" *ngIf="!uploading && !completed"><mat-icon>close</mat-icon></button>
        </div>
      </div>
    </section>
    <section class="panel">
      <h3>CSV File</h3>
      <button mat-stroked-button color="primary" (click)="csvInput.click()" [disabled]="uploading || completed || csvItem">
        <mat-icon>list_alt</mat-icon> Select CSV
      </button>
      <input #csvInput type="file" accept=".csv,text/csv" (change)="onSelectCsv($event)" hidden>
      <div class="csv-card" *ngIf="csvItem">
        <mat-icon class="csv">list_alt</mat-icon>
        <span class="name" [title]="csvItem.file.name">{{csvItem.file.name}}</span>
        <span class="size">{{csvItem.file.size | number}} bytes</span>
        <div class="progress" *ngIf="csvItem.status==='uploading'">
          <div class="bar" [style.width.%]="csvItem.progress"></div>
        </div>
        <mat-icon *ngIf="csvItem.status==='pending'">schedule</mat-icon>
        <mat-icon class="ok" *ngIf="csvItem.status==='success'">check_circle</mat-icon>
        <mat-icon class="err" *ngIf="csvItem.status==='error'" matTooltip="{{csvItem.error}}">error</mat-icon>
        <button mat-icon-button color="warn" (click)="removeCsv()" *ngIf="!uploading && !completed"><mat-icon>close</mat-icon></button>
      </div>
    </section>
  </div>
  <div *ngIf="validationMsg" class="validation"><mat-icon>error_outline</mat-icon> {{validationMsg}}</div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <div class="overall" *ngIf="uploading">
    <mat-progress-spinner mode="determinate" [value]="overall" diameter="30"></mat-progress-spinner>
    <span>{{overall}}%</span>
  </div>
  <div class="success" *ngIf="completed"><mat-icon class="ok big">check_circle</mat-icon><span>Request submitted successfully for processing. Please check Resources/Statistics section later to verify.</span></div>
  <button mat-button (click)="close()">Close</button>
  <button mat-raised-button color="primary" (click)="startUpload()" [disabled]="!canUpload()">Start Upload</button>
</mat-dialog-actions>
<!-- END CHANGE -->
